import './activity-block.scss';

import ActivityBlock from './ActivityBlock';

export default ActivityBlock;
